import React, { useState } from 'react'
import './text-field.css'
import { useTranslation } from 'react-i18next'
import hidePwd from './hidepassword.svg'
import showPwd from './showpassword.svg'

export interface TextFieldProps extends React.HTMLProps<HTMLInputElement> {
  errorText?: string
}

export function TextField({ type = 'text', onChange = () => { }, onFocus = () => { }, onBlur = () => { }, name, placeholder, errorText, disabled, "aria-invalid": invalid, "aria-describedby": describedBy, ...otherProps }: TextFieldProps) {
  const [showText, setShowText] = useState(type !== 'password')
  const newPasswordToggleImg = showText ? showPwd : hidePwd
  const { t } = useTranslation()

  function handleToggleVisibility() {
    setShowText(!showText)
  }

  const errorTextId = name ? `${name}-text-input-error` : 'text-input-error'

  return (
    <>
      <div className={`text-input-field-wrapper ${disabled ? "disabled" : ""}`}>
        <input type={showText ? 'text' : 'password'}
          id={name ? `${name}-text-input` : 'text-input'}
          data-testid={name ? `${name}-text-input-test` : 'text-input-test'}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          aria-invalid={!!errorText || invalid}
          aria-describedby={errorText ? `${errorTextId} ${describedBy || ""}` : describedBy}
          {...otherProps} />
        {type === 'password'
          ? <button className='toggle-button' data-testid={'toggle-button'} type={'button'} onClick={handleToggleVisibility}>
            <img id='visibility-toggle-new' src={newPasswordToggleImg} alt={t('password_visibility_toggle', 'Toggle Password Visibility')} />
          </button> : null
        }
      </div>
      {errorText && <p className="error-text" id={errorTextId} data-testid={errorTextId}>{errorText}</p>}
    </>
  )
}

TextField.defaultProps = {
  type: 'text',
  onChange: () => { },
  onFocus: () => { },
  onBlur: () => { }
}
